

























import { LANG } from "@/common/constant";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Vue } from "vue-property-decorator";

@Component({
  name: "qLanguageTab",
})
export default class QLanguageTab extends Vue {
  @Prop({
    default: LANG.JA,
  })
  public value: any;

  @Prop({
    required: true,
    default: [LANG.EN],
  })
  public languages: any;

  public selectedLang = LANG.JA;

  @Watch("languages")
  public setToDefault(): void {
    if (!this.languages.includes(this.value)) {
      this.$emit("input", LANG.JA);
    }
  }

  public changeLang(lang) {
    this.$emit("input", lang);
  }
}
